export const createPasswordToggleIcon = () => {
    const inputContainer = document.querySelectorAll('.Form__formField___2DWhT');
    const icon = document.createElement("span");
    const input = document.querySelector('input[type="password"]');
    icon.classList.add('inactive');
    icon.innerHTML = `<img alt="logo" class="eye-icon" src=${require('@/assets/img/eye.svg')}>`;
    inputContainer[1].appendChild(icon);
    icon.addEventListener('click', () => {
        const type = input.getAttribute('type');
        switch (type) {
            case 'password': {
                icon.classList.remove('inactive');
                input.type = 'text';
                return;
            }
            case 'text': {
                icon.classList.add('inactive');
                input.type = 'password';
                return;
            }
        }
    });
}
